import { getSelectors } from '@repo/core'
import { selectorsConfig } from './selectors.const'

export const cashMovementDetailSelector = getSelectors({
  getRootPath: selectorsConfig.cashMovementDetailSelector.getRootPath,
})
